module.exports = __webpack_public_path__ + "static/media/flights_fraud.9b78e579.jpg";